module.exports = __webpack_public_path__ + "front/img/kv06.7d3f4a6f.png";